export const JuridicalTypeEnum = {
  NaturalPerson: 0,
  LegalPerson: 1,
};
